module.exports = __webpack_public_path__ + "static/media/drawtiles.9da5f143.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/tilemaps/tiles/drawtiles.png
// module id = 873
// module chunks = 0